import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Switch, Typography, Grid } from '@material-ui/core';
import { useDispatch } from "react-redux";
import { eliminarCentroFeriado, setCentroFeriado } from "../../../../actions/turnos/feriados";
import { armarParametros } from "../../../../helpers/parametros";
import { fetchConToken } from "../../../../helpers/fetch";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";
import { startAlerta } from "../../../../actions/ui/alertas";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";

const useStyles = makeStyles({
    root:{
        background:'#212121'
    },
    TypographyRoot:{
        // color:'white'
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },
    switchBase2:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
              backgroundColor: '#B7A931',
              opacity: 1,
              border: 'none',
            },
          },
    },
    checked:{},
    track: {},
    swithColorPrimary:{
        color: 'yellow'
    }
});

export const CentroMedico = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { idFeriado, idCentroMedico, seleccionado, descripcionCentro, disabled }= props; 

  const [ turnosTomados, setTurnosTomados ] = useState(0);
  const [ openQuestionTurnos, setOpenQuestionTurnos ] = useState(false);

  const handleChange = e => {
      const verificarTurnosTomados = async () => {
          setTurnosTomados(0);
          try{
              dispatch(startSpinner());
              const parametros = armarParametros(null, idCentroMedico, null, null, null, props.fecha, null, null, null, null, null, null, null, null, null, true);
              const response = await fetchConToken(`Agenda/traerPorFecha?${parametros}`);
              const contentType = response.headers.get("content-type");
              if (contentType && contentType.indexOf("application/json") !== -1) {
                  const lista = await response.json();
                  if (response.status !== 200) throw lista.errores;
                  if(lista.length > 0){                       //Valido si tiene turnos tomados para esa fecha
                      setTurnosTomados(lista);
                      setOpenQuestionTurnos(true);
                  }else{
                      handleConfirm();
                  }
              }
              dispatch(finishSpinner());
          } catch (err){
              dispatch(finishSpinner());
              dispatch(startAlerta(err, "warning", `¡Error!`));
          }
      }

      if(e.target.checked){
        verificarTurnosTomados();
      }
      else{
        dispatch( eliminarCentroFeriado(idFeriado, idCentroMedico) );
      }
  }

  const handleConfirm = () => {
      dispatch( setCentroFeriado(idFeriado, idCentroMedico, () => setOpenQuestionTurnos(false)) );
  }

  return (
    <>
        <Grid item xs={3} md={1}>
            <Switch 
                checked={seleccionado}
                name={descripcionCentro}
                value={idCentroMedico}
                disabled={disabled}
                onChange={handleChange}
                classes={{switchBase:classes.switchBase,checked:classes.checked,track:classes.track}}
            />
        </Grid>
        <Grid item xs={9} md={3}>
            <Typography className={classes.TypographyRoot} >{descripcionCentro}</Typography>
        </Grid>
        {openQuestionTurnos && 
            <AlertFinalizadoStepper
                open={openQuestionTurnos}
                pregunta={`Turnos tomados`}
                dialogText={`Se van a cancelar ${turnosTomados.length} turnos tomados de ${descripcionCentro} esta seguro?`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Continuar"}
                handleClose={() => setOpenQuestionTurnos(false)}
                handleSend={handleConfirm}
            />
        }  
    </>
  );
};